/*
 * Presento Pronto: 1-Klick-Hinzufuegen <pp-card-upsell>.
 * Genutzt von "Die passende Karte dazu?" (blocks/pp-card-upsell.liquid) und dem Set-Angebot im Warenkorb
 * (snippets/pp-cart-offer.liquid) und dem Umschlag-Overlay (snippets/pp-envelope-upsell.liquid).
 * Optional data-quantity am Button (Standard 1).
 *
 * Eigenes Asset statt {% javascript %} im Block: Block-Skripte laufen nur auf Seiten, auf denen der Block
 * gerendert wurde (Produktseite). Der Warenkorb-Drawer braucht das Element auf jeder Seite; er laedt diese
 * Datei an einer immer gerenderten Stelle (snippets/cart-drawer.liquid).
 */
if (!customElements.get('pp-card-upsell')) {
  class PpCardUpsell extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const button = event.target.closest('button[data-variant-id]');
      if (!button || button.disabled) return;
      this.addToCart(button);
    };

    get source() {
      if (this.dataset.source) return this.dataset.source;
      return this.closest('.pp-cart-offer') ? 'cart_set_offer' : 'pdp_card_upsell';
    }

    track(variantId, quantity = 1) {
      const detail = { source: this.source, variantId, quantity };
      this.dispatchEvent(new CustomEvent('pp:upsell:add', { bubbles: true, detail }));
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('pp_upsell_add', detail);
        }
      } catch (error) {
        /* Analytics duerfen den Kauf nie blockieren */
      }
    }

    async fetchCart() {
      const cartItems = document.querySelector('cart-items-component');
      if (cartItems) {
        await customElements.whenDefined('cart-items-component');
        if (typeof cartItems.fetchCartData === 'function') return cartItems.fetchCartData();
      }
      const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
      const response = await fetch(`${cartUrl}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      return response.json();
    }

    async addToCart(button) {
      const status = this.querySelector('.pp-upsell__status');
      const label = button.querySelector('.pp-upsell__add-label');
      const variantId = Number(button.dataset.variantId);
      const quantity = Math.max(1, Number(button.dataset.quantity) || 1);
      const addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((element) => element.dataset.sectionId)
        .filter(Boolean);

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';

      let CartLinesUpdateEvent = null;
      let deferred = null;
      try {
        ({ CartLinesUpdateEvent } = await import('@shopify/events'));
        deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(variantId), quantity }],
            promise: deferred.promise,
          })
        );
      } catch (error) {
        CartLinesUpdateEvent = null;
        deferred = null;
      }

      let added = false;
      let sections;
      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }], sections: sectionIds.join(',') }),
        });
        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message || 'add failed');
        added = true;
        sections = data.sections;

        /* Ab hier liegt die Karte im Warenkorb: der Button bleibt auf "hinzugefuegt", auch wenn
           das Nachladen des Warenkorbs danach scheitert (sonst Doppelklick = doppelte Karte). */
        button.dataset.added = 'true';
        if (label) label.textContent = this.dataset.addedLabel;
        if (status) status.textContent = '';
        this.track(variantId, quantity);
      } catch (error) {
        console.error('[pp-card-upsell]', error);
        button.disabled = false;
        if (status) status.textContent = this.dataset.errorLabel;
      }

      /* Wie product-form.js: das Event-Promise wird immer aufgeloest (bei Fehler mit didError: true),
         nie verworfen - so gibt es keine unbehandelten Rejections in Horizons Warenkorb-Listenern.
         Die mitgelieferten sections aktualisieren Drawer/Warenkorbseite auf dem normalen Horizon-Weg. */
      try {
        if (deferred && CartLinesUpdateEvent) {
          let cart = null;
          try {
            cart = await this.fetchCart();
          } catch (error) {
            console.warn('[pp-card-upsell] Warenkorb konnte nicht nachgeladen werden', error);
          }
          /* Ohne Warenkorb-Daten den Zaehler aus dem Header-Icon fortschreiben statt ihn zu nullen */
          const cartIcon = document.querySelector('cart-icon');
          const knownCount = cartIcon ? Number(cartIcon.currentCartCount) : NaN;
          const fallbackCount = Number.isFinite(knownCount) ? knownCount + (added ? quantity : 0) : undefined;
          deferred.resolve({
            cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : null,
            detail: {
              items: cart ? cart.items : [],
              source: 'pp-card-upsell',
              itemCount: cart ? 1 : fallbackCount,
              sections,
              didError: !added,
            },
          });
        }
      } finally {
        button.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('pp-card-upsell', PpCardUpsell);
}
